import { createStore } from "redux";
import rootReducer from "./Reducers/rootReducer";
import { loadState, saveState } from "./localStorage";

const persistedState = loadState();
const store = createStore(rootReducer, persistedState);

store.subscribe(() => {
  saveState({
    userInfo: store.getState().userInfo
  });
});

export default store;
